(function () {
  function renderVidyardPlayers(root) {
    if (!root || !window.VidyardV4 || !window.VidyardV4.api) return;

    root.querySelectorAll('img.vidyard-player-embed:not([data-vidyard-rendered])').forEach(function (node) {
      try {
        window.VidyardV4.api.renderPlayer(node);
        node.setAttribute('data-vidyard-rendered', 'true');
      } catch (error) {
        /* Vidyard may not be ready yet */
      }
    });
  }

  function loadVidyardScript() {
    if (document.querySelector('[data-ghost-vidyard-script]')) return;

    var script = document.createElement('script');
    script.src = 'https://play.vidyard.com/embed/v4.js';
    script.async = true;
    script.type = 'text/javascript';
    script.setAttribute('data-ghost-vidyard-script', '');
    script.addEventListener('load', function () {
      document.querySelectorAll('[data-ghost-social-proof-shell]').forEach(function (shell) {
        renderVidyardPlayers(shell);
      });
    });
    document.head.appendChild(script);
  }

  function initCarousel(carousel) {
    var shell = carousel.closest('[data-ghost-social-proof-shell]') || carousel.parentElement;
    var root = shell || carousel;
    var slides = Array.from(carousel.querySelectorAll('[data-slide]'));
    var metas = Array.from(root.querySelectorAll('[data-meta]'));
    var dots = Array.from(root.querySelectorAll('[data-dot]'));
    var prevBtn = carousel.querySelector('[data-prev]');
    var nextBtn = carousel.querySelector('[data-next]');
    var touchStartX = null;
    var activeIndex = 0;

    if (slides.length === 0) return;

    var normalize = function (index) {
      var total = slides.length;
      return (index + total) % total;
    };

    var paint = function () {
      var prevIndex = normalize(activeIndex - 1);
      var nextIndex = normalize(activeIndex + 1);

      slides.forEach(function (slide, idx) {
        slide.classList.remove('is-prev', 'is-active', 'is-next');

        if (idx === activeIndex) {
          slide.classList.add('is-active');
        } else if (idx === prevIndex) {
          slide.classList.add('is-prev');
        } else if (idx === nextIndex) {
          slide.classList.add('is-next');
        }
      });

      metas.forEach(function (meta, idx) {
        meta.classList.toggle('is-active', idx === activeIndex);
      });

      dots.forEach(function (dot, idx) {
        dot.classList.toggle('is-active', idx === activeIndex);
      });

      renderVidyardPlayers(root);
    };

    var goTo = function (index) {
      activeIndex = normalize(index);
      paint();
    };

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goTo(activeIndex - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goTo(activeIndex + 1);
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(Number(dot.dataset.index));
      });
    });

    slides.forEach(function (slide) {
      slide.addEventListener('click', function () {
        var index = Number(slide.dataset.index);
        if (!Number.isNaN(index) && index !== activeIndex) {
          goTo(index);
        }
      });
    });

    root.addEventListener('touchstart', function (event) {
      if (!event.touches || !event.touches.length) return;
      touchStartX = event.touches[0].clientX;
    }, { passive: true });

    root.addEventListener('touchend', function (event) {
      if (touchStartX === null || !event.changedTouches || !event.changedTouches.length) return;

      var diff = touchStartX - event.changedTouches[0].clientX;
      touchStartX = null;

      if (Math.abs(diff) <= 40) return;
      if (diff > 0) {
        goTo(activeIndex + 1);
        return;
      }
      goTo(activeIndex - 1);
    }, { passive: true });

    paint();
  }

  function init() {
    document.querySelectorAll('[data-ghost-social-proof]').forEach(initCarousel);
    loadVidyardScript();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
